import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { View } from '@shared/interfaces/page';
import { PageService } from '@shared/services/entities/page.service';
import { Store } from '@ngrx/store';
import { currentApp } from '@store/reducers/app.reducer';
import { filter, NEVER, Observable, switchMap, take } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const pageResolverFn: ResolveFn<View> = (
	route: ActivatedRouteSnapshot
): Observable<View> => {
	const pageService = inject(PageService);
	const router = inject(Router);
	const store = inject(Store);

	const appId = Number(route.paramMap.get('appId'));
	const viewId = Number(route.paramMap.get('pageId'));

	return store.select(currentApp).pipe(
		filter((app) => app?.id === appId),
		take(1),
		switchMap(() => pageService.getView(String(appId), viewId)),
		catchError((error) => {
			router.navigateByUrl('/error', {
				state: { data: 'PAGE_NOT_FOUND', error: error.message }
			});
			return NEVER;
		})
	);
};
